import { AfterViewInit, Component, ElementRef, ViewChild } from "@angular/core";
import { DebrisService } from "../../ambients/debris-service";
import { EventsWebsocketService } from "../../../services/entities/events-websocket.service";
import { EventSenderService } from "../event-sender.service";
import { generateUUID } from "three/src/math/MathUtils.js";
import {
  CollisionType,
  Components,
  Entity,
  EntityType,
} from "src/app/state/entities/entity.model";
import { Vector3 } from "three";
import { MapInputService } from "../../inputs/input-middlewares/map-input.middleware";
import { ThreeInputService } from "../../inputs/input-middlewares/three-input.middleware";
import { InputService } from "../../inputs/services/input.service";
import { ThreeService } from "../../rendering/threejs/three.service";
import { SurfaceService } from "../../surface/surface.service";
import {CanvasService} from "../../surface/canvas/canvas.service";
import {Store} from "@ngrx/store";
import {ActivatedRoute, Router} from "@angular/router";
import {BinstService} from "../../binst.service";
import {cameraActions} from "../../../state/camera/camera.actions";

@Component({
  selector: "binsta-post.test",
  standalone: true,
  imports: [],
  templateUrl: "./post.test.component.html",
  styleUrl: "./post.test.component.scss",
})
export class PostTestComponent implements AfterViewInit {
  constructor(
      private canvasService: CanvasService,
      private surfaceService: SurfaceService,
      private store: Store,
      private router: Router,
      private route: ActivatedRoute,
      private binstService: BinstService,
  ) { }

  @ViewChild("canvas")
  private canvasRef: ElementRef;

  public rotationSpeedX = 0.005;
  public rotationSpeedY = 0.005;
  animationValue = 0;

  debug = false;

  private get canvas(): HTMLCanvasElement {
    return this.canvasRef.nativeElement;
  }


  setupSubscriptions() {
    this.router.events.subscribe((event) => {
      this.store.dispatch(
          cameraActions.triggeredCanvasResizeAnimation({ durationMs: 500 }),
      );
      // }
    })
  }

  async ngAfterViewInit(): Promise<void> {
    this.binstService.startBinstView()
    this.setupSubscriptions();
    this.canvasService.setDocument(document);
    await this.binstService.setupCanvas(this.canvas);
    await this.binstService.setupSurfaces()
    await this.binstService.startThree()
    await this.binstService.startDebris()
    await this.binstService.setupInputs()
    await this.surfaceService.updateCamera()
    // const canvass = CanvasState.canvass.values();
    // for (let canv of canvass) {
    //   canv.classList.add("canvas")
    //   // canv.classList.add("canvas-container")
    //   this.containerRef.nativeElement.appendChild(canv);
    //   // document.body.appendChild(canv)
    // }
    await this.surfaceService.updateCamera()
  }


}
